import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://tlzkfqdzkmsctlwysgeq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRsemtmcWR6a21zY3Rsd3lzZ2VxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM0NTgzNTIsImV4cCI6MjA3OTAzNDM1Mn0.lkourcl6WOIHQEaReK1TjjK2fvvyRddQn8BDYnsPlZ4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);


export const getSession = async () => {
    const { data, error } = await supabase.auth.getSession();
    
    if (error) {
        console.error('세션 가져오기 에러:', error);
        return null;
    }
    
    return data.session;
};
